export class changePass {
    OldPassword: any;
    NewPassword: any;
    ConfirmPassword: any;
    
}